module.exports = __webpack_public_path__ + "img/CChampion64_ua.2a177fac.webp";